
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

export class GenIceSector {
    static readonly RESIDENTIAL: GenIceSector = new GenIceSector('RESIDENTIAL');
    static readonly NON_RESIDENTIAL: GenIceSector = new GenIceSector('NON_RESIDENTIAL');
    static readonly ALL: GenIceSector = new GenIceSector('ALL');

    public readonly name: string;

    private constructor(name: string) {
        this.name = name;
    }

    static forName(name: string) {
        if (name === 'RESIDENTIAL') return GenIceSector.RESIDENTIAL;
        if (name === 'NON_RESIDENTIAL') return GenIceSector.NON_RESIDENTIAL;
        if (name === 'ALL') return GenIceSector.ALL;
        throw new Error('Unexpected value for GenIceSector:' + name);
    }

    static values(): GenIceSector[] {
        return [
            GenIceSector.RESIDENTIAL,
            GenIceSector.NON_RESIDENTIAL,
            GenIceSector.ALL,
        ];
    }

    toJSON(): string {
        return this.name;
    }

    toString(): string {
        return this.name;
    }
}

